import { AsyncPipe, CommonModule, JsonPipe, NgClass } from '@angular/common';
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { CmsService, I18nModule, SemanticPathService, TranslatePipe, UrlModule } from '@spartacus/core';
import { CmsComponentData, MediaComponent, MediaModule } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import {
  GoogleTagManagerEvent,
  GoogleTagManagerService,
} from 'src/app/service/googletagmanager/google-tag-manager.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { RemoveImageTitleAttrDirective } from '../../../shared/remove-title-attr.directive';
import { SlickCarouselUtilService } from '../../../utility/slick-carousel.util';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-special-offer',
  templateUrl: './special-offer.component.html',
  styleUrls: ['./special-offer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [SlickCarouselUtilService],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    MediaModule,
    I18nModule,
    SlickCarouselModule,
    SharedModule
  ],
})
export class SpecialOfferComponent implements OnInit {
  slickConfig: any;
  data$: Observable<any[]> = this.componentData.data$;

  /**
   * returns an Obervable string for the title.
   */
  title$: Observable<string> = this.componentData.data$.pipe(map((data) => data.title));

  category$: Observable<any> = this.componentData.data$.pipe(
    filter((data) => !!data?.categoryFeatures),
    switchMap((data) =>
      combineLatest(
        data.categoryFeatures
          .split(' ')
          .splice(0, data.itemCount)
          .map((component: string) =>
            this.cmsService.getComponentData<any>(component).pipe(
              map((d) => {
                return {
                  ...d,
                };
              })
            )
          )
      )
    )
  );

  activeLanguage$: Observable<string> = this.languageService.getActive();
  queryCodec: HttpUrlEncodingCodec = new HttpUrlEncodingCodec();
  businessType: string;

  constructor(
    protected componentData: CmsComponentData<any>,
    protected cmsService: CmsService,
    private deviceService: DeviceDetectorService,
    private languageService: ShimanoLanguageService,
    protected semanticPathService: SemanticPathService,
    private currentBusinesstype: CurrentBusinessType,
    private gtmService: GoogleTagManagerService
  ) {
    const slickConfig = new SlickCarouselUtilService();
    const slickObj = slickConfig.defaultConfig;
    slickObj.slidesToShow = 4;
    slickObj.slidesToScroll = 4;
    if (!this.deviceService.isDesktop()) {
      slickObj.arrows = false;
    }
    this.slickConfig = slickObj;
  }

  getLink(categoryFeatureData: any) {
    if (categoryFeatureData.category) {
      return this.semanticPathService.transform({
        cxRoute: 'category',
        params: {
          code: categoryFeatureData.category,
        },
      });
    } else if (categoryFeatureData.url) {
      return this.getRouterUrl(categoryFeatureData.url);
    } else {
      return null;
    }
  }

  getRouterUrl(url: any): any[] {
    if (typeof url === 'string') {
      return [this.getAbsoluteUrl(url)];
    }
    return url;
  }

  getAbsoluteUrl(url: string) {
    const urlRouterLink = url.split('?')[0];
    return urlRouterLink.startsWith('/') ? urlRouterLink : '/' + urlRouterLink;
  }

  getQueryParams(url: string): any {
    const hasQueryParams = url && url.split('?').length > 1;
    if (hasQueryParams) {
      const queryParams = url.split('?')[1].split('=')[1];
      return { query: this.queryCodec.decodeValue(queryParams) };
    }
    return null;
  }

  gtmClickPromotion(data: any) {
    if (data.url) {
      let promoIDs = [];
      let tempUrl = data.url;

      while (tempUrl.includes('promo:')) {
        const promoID = tempUrl.split('promo:')[1].split(':')[0].trim();
        promoIDs.push(promoID);
        tempUrl = tempUrl.split(`promo:${promoID}`).join('');
      }

      if (promoIDs.length > 0) {
        promoIDs.forEach((id) => {
          const gtmTag = {
            event: GoogleTagManagerEvent.SELECT_PROMOTION,
            ecommerce: '',
            creative_slot: 'Special offers - Homepage Carousel',
            promotion_id: id,
            promotion_name: '',
          };
          if (data) {
            this.gtmService.pushTag({
              ecommerce: null,
              search_term: '',
              results_page: '',
              affiliation: '',
              content_type: '',
              content_id: '',
              content_name: '',
            });
            this.gtmService.pushTag(gtmTag);
          }
        });
      }
    }
  }

  ngOnInit() {
    this.businessType = this.currentBusinesstype.getBusinessType();
  }
}
